import { render } from "./PlanEventCollectionPage.vue?vue&type=template&id=9bcf0022&ts=true"
import script from "./PlanEventCollectionPage.vue?vue&type=script&lang=ts"
export * from "./PlanEventCollectionPage.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__